import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  peoplePage: {
    // padding: "0px 54px"
    minHeight: "600px",
  }
});

export default styles;
